// extracted by mini-css-extract-plugin
export default {"containerCenter":"styles_containerCenter__4bOO8","login":"styles_login__P+U-z","modulo":"styles_modulo__uYpBT","serverInfo":"styles_serverInfo__3b8J6"};